'use strict';

if (!Symbol.species) {
    Symbol.species = Symbol.for('@@species');
}



//////////////////
// WEBPACK FOOTER
// ./~/ml-fnn/~/ml-matrix/src/symbol-species.js
// module id = 194
// module chunks = 0